import _get from "lodash/get";
import * as timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";

import { getCheckId } from "../index";
import { getDateFromString } from "../../util";
import { METRIC_TYPES } from "../../constants/global";
import { convertMetrics } from "../../helpers/metrics";
import { MetricsRequest } from "../../protos/auther_pb";
import { AUTHER_CLIENT, getRequestMetadata } from "../index";

const getUptimeMetrics = async ({ startTime, endTime }) => {
  const request = new MetricsRequest();
  const checkId = getCheckId();
  request.setCheckId(checkId);

  const startTs = new timestamp_pb.Timestamp();
  const s = getDateFromString(startTime);
  startTs.setSeconds(s?.seconds);
  startTs.setNanos(0);
  request.setStartTime(startTs);

  const endTs = new timestamp_pb.Timestamp();
  const end = getDateFromString(endTime);
  endTs.setSeconds(end?.seconds);
  endTs.setNanos(0);
  request.setEndTime(endTs);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.uptimeMetrics(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("uptimeMetrics failed", err.code, err.message);
        reject(err);
      } else {
        const uptimeMetrics = response['u'][0];
        const results = uptimeMetrics.length ? convertMetrics(uptimeMetrics, METRIC_TYPES.CHECK_PASSED) : [];
        resolve(results);
      }
    });
  });
};

const getRequestLatency = async ({ startTime, endTime }) => {
  const request = new MetricsRequest();
  const checkId = getCheckId();
  request.setCheckId(checkId);

  const startTs = new timestamp_pb.Timestamp();
  const s = getDateFromString(startTime);
  startTs.setSeconds(s?.seconds);
  startTs.setNanos(0);
  request.setStartTime(startTs);

  const endTs = new timestamp_pb.Timestamp();
  const end = getDateFromString(endTime);
  endTs.setSeconds(end?.seconds);
  endTs.setNanos(0);
  request.setEndTime(endTs);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.latencyMetrics(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("latencyMetrics failed", err.code, err.message);
        reject(err);
      } else {
        const requestLatency = response['u'][0];
        const results = requestLatency.length ? convertMetrics(requestLatency, METRIC_TYPES.REQUEST_LATENCY) : [];
        resolve(results);
      }
    });
  });
};

export { getRequestLatency, getUptimeMetrics };
